import React from "react";
import { Editor } from "@tiptap/react";
import {
  Bold,
  Italic,
  AlignLeft,
  AlignCenter,
  AlignJustify,
} from "lucide-react";

interface ToolbarProps {
  editor: Editor;
}

const TipTapToolbar: React.FC<ToolbarProps> = ({ editor }) => {
  if (!editor) return null;

  const baseButtonClass =
    "p-2 rounded-lg flex items-center justify-center hover:bg-gray-100 transition-all hover:border-gray-200";
  const activeClass =
    "bg-gray-200 border-gray-300 shadow-inner text-black font-semibold";
  const groupClass =
    "flex items-center gap-1 bg-white px-2 py-1 rounded-xl border border-gray-200";

  return (
    <div className="w-full flex flex-wrap gap-2 p-3 bg-white sticky top-0 z-10 rounded-t-xl">
      {/* TEXT FORMATTING */}
      <div className={groupClass}>
        <button
          type="button"
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
          className={`${baseButtonClass} ${
            editor.isActive("bold") ? activeClass : ""
          }`}
          title="Bold"
        >
          <Bold size={12} strokeWidth={2.2} />
        </button>

        <button
          type="button"
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!editor.can().chain().focus().toggleItalic().run()}
          className={`${baseButtonClass} ${
            editor.isActive("italic") ? activeClass : ""
          }`}
          title="Italic"
        >
          <Italic size={12} strokeWidth={2.2} />
        </button>
      </div>

      {/* ALIGNMENT OPTIONS */}
      <div className={groupClass}>
        <button
          type="button"
          onClick={() => editor.chain().focus().setTextAlign("left").run()}
          className={`${baseButtonClass} ${
            editor.isActive({ textAlign: "left" }) ? activeClass : ""
          }`}
          title="Align Left"
        >
          <AlignLeft size={12} strokeWidth={2.2} />
        </button>

        <button
          type="button"
          onClick={() => editor.chain().focus().setTextAlign("center").run()}
          className={`${baseButtonClass} ${
            editor.isActive({ textAlign: "center" }) ? activeClass : ""
          }`}
          title="Align Center"
        >
          <AlignCenter size={12} strokeWidth={2.2} />
        </button>

        <button
          type="button"
          onClick={() => editor.chain().focus().setTextAlign("justify").run()}
          className={`${baseButtonClass} ${
            editor.isActive({ textAlign: "justify" }) ? activeClass : ""
          }`}
          title="Justify"
        >
          <AlignJustify size={12} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  );
};

export default TipTapToolbar;
